import styled from 'styled-components';
import { Form, FormItem } from '@/components';
import { Select } from '@/ui';
import { COLORS } from '@/theme';

export const StyledForm = styled(Form)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledButtonWrap = styled.div`
  width: 100%;
  margin-top: 0.5rem;
  display: flex;
  justify-content: flex-end;
`;

export const StyledFormItem = styled(FormItem)`
  .ant-form-item-control-input,
  .ant-form-item-control-input-content {
    height: auto;
    align-items: flex-start;
  }
`;

export const StyledSelect = styled(Select)`
  &&& {
    .ant-select-selection-placeholder {
      color: ${COLORS.BLACK};
    }

    .ant-select-selector {
      height: auto !important;
      min-height: 2rem;
      max-height: 23rem;
      overflow-y: auto !important;
      align-items: flex-start;
      overflow: visible;
      padding-top: 0.15rem;
    }

    .ant-select-selection-search {
      min-width: 16rem;
      flex: 1 0 auto;
    }

    .ant-select-selection-overflow {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      white-space: normal;
      flex-wrap: wrap;
    }

    .ant-select-selection-overflow-item {
      align-self: auto !important;
    }
    /* Keep tag truncation */
    .ant-select-selection-overflow-item span {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 100%;
    }

    .ant-select-selection-overflow-item-rest div {
      border: none;
      color: ${COLORS.GRAY_PRIMARY};
    }

    .ant-select-selection-overflow-item-suffix {
      padding-left: 0.25rem;
    }

    .ant-select-clear {
      inset-inline-end: 0.25rem;
      top: 50%;
      width: fit-content;
      height: fit-content;
    }
  }
`;
